export default __webpack_public_path__ + "locales/ru/WebPlugins.json?hash=c549a3f4965dcee948bb3abe55f8d5cd";